(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card"] && !Shopify.designMode) return;
  try {
    (function() {
  if (window.__shoplcProductCardInit) return;
  window.__shoplcProductCardInit = true;

  function mobileOpenMiniCart() {
    var cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return;
    }
    if (cartDrawer && typeof cartDrawer.showDialog === 'function') {
      cartDrawer.showDialog();
      return;
    }
    if (cartDrawer) {
      customElements.whenDefined('cart-drawer-component').then(function() {
        if (typeof cartDrawer.open === 'function') cartDrawer.open();
      });
      return;
    }
    var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (trigger) trigger.click();
  }

  function mobileDirectAddToCart(quickAdd, btn) {
    var form = quickAdd.querySelector('form');
    if (!form) return false;
    var variantInput = form.querySelector('input[name="id"]');
    var variantId = variantInput && (variantInput.value || variantInput.getAttribute('value'));
    if (!variantId) return false;
    var quantityInput = form.querySelector('input[name="quantity"]');
    var quantity = (quantityInput && Number(quantityInput.value)) || 1;

    if (btn) {
      btn.setAttribute('disabled', '');
      btn.style.opacity = '0.6';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: Number(variantId), quantity: quantity })
    })
      .then(function(res) { return res.json(); })
      .then(function(addData) {
        if (addData.status) {
          console.error('Mobile direct ATC error:', addData.description || addData.message);
          return;
        }
        return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            document.querySelectorAll('[data-cart-count], [data-cart-icon-count], .cart-count, .header__cart-count, .header-actions__cart-count').forEach(function(el) {
              el.textContent = String(cart.item_count || 0);
              if (cart.item_count > 0) {
                el.classList.remove('hidden', 'is-hidden');
                el.removeAttribute('hidden');
              }
            });
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { addedItem: addData, cart: cart } }));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            mobileOpenMiniCart();
          });
      })
      .catch(function(err) { console.error('Mobile direct ATC fetch error:', err); })
      .finally(function() {
        if (btn) {
          btn.removeAttribute('disabled');
          btn.style.opacity = '';
        }
      });

    return true;
  }

  document.addEventListener('click', function(e) {
    if (!(e.target instanceof Element)) return;
    var btn = e.target.closest('.shoplc-product-card__quick-add-cta, .shoplc-product-card__variant-overflow');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var card = btn.closest('.shoplc-product-card');
    if (!card) return;
    var quickAdd = card.querySelector('quick-add-component');

    if (quickAdd && quickAdd.hasAttribute('data-direct-atc')) {
      if (typeof quickAdd.handleClick === 'function') {
        quickAdd.handleClick(e);
      } else {
        mobileDirectAddToCart(quickAdd, btn);
      }
      return;
    }

    if (quickAdd && typeof quickAdd.handleClick === 'function') {
      quickAdd.handleClick(e);
      return;
    }
    var dialog = document.getElementById('quick-add-drawer');
    if (dialog && typeof dialog.showDialog === 'function') {
      dialog.showDialog();
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
